import React, { useState, useEffect } from "react";
import { Table } from "react-bootstrap";
import {
  getEstados,
  deleteEstado,
  getEstadoById,
} from "../helpers/rutaEstados";
import ModalEstado from "./ModalEstado";
import "../css/tableclientes.css";

const TableEstados = () => {
  const [estados, setEstados] = useState({
    data: {},
    loading: true,
  });

  const [estado, setEstado] = useState({});
  const [show, setShow] = useState(false);

  useEffect(() => {
    consultaEstados();
  }, []);

  const consultaEstados = () => {
    getEstados().then((datos) => {
      console.log("📦 Estado:", datos);
      setEstados({
        data: datos,
        loading: false,
      });
    });
  };

  const handleClose = () => {
    setShow(false);
    consultaEstados();
  };

  const handleShow = () => setShow(true);

  const modificaEstado = (id) => {
    getEstadoById(id).then((resp) => {
      if (resp.ok) {
        setEstado(resp.estado); // ✅ ahora sí solo el objeto estado
        handleShow();
      } else {
        console.error("❌ Error al obtener estado:", resp.error);
      }
    });
  };

  const eliminarEstado = (id) => {
    const confirmar = window.confirm("¿Está seguro que desea borrar el estado?");
    if (confirmar) {
      deleteEstado(id).then(() => {
        consultaEstados();
      });
    }
  };

  return (
    <div className="table-container">
      {!estados.loading && (
        <>
          <div className="col-12 mt-4" />
          <div>
            <Table striped bordered hover className="table-container">
              <thead>
                <tr className="header">
                  <th>Acciones</th>
                  <th>Nro</th>
                  <th className="cli">Estado</th>
                </tr>
              </thead>
              <tbody>
                {estados.data.estados.map((estado) =>
                  estado.activo ? (
                    <tr key={estado._id}>
                      <td>
                        <button
                          className="btn btn-primary"
                          onClick={() => modificaEstado(estado._id)}
                        >
                          <i className="fa fa-pencil-square-o" aria-hidden="true" />
                        </button>
                        <button
                          className="btn btn-danger ml-2"
                          onClick={() => eliminarEstado(estado._id)}
                        >
                          <i className="fa fa-trash-o" aria-hidden="true" />
                        </button>
                      </td>
                      <td>{estado.codest}</td>
                      <td>{estado.estado}</td>
                    </tr>
                  ) : null
                )}
              </tbody>
            </Table>
          </div>
          <ModalEstado
            show={show}
            handleClose={handleClose}
            estado={estado}
          />
        </>
      )}
    </div>
  );
};

export default TableEstados;
